// extracted by mini-css-extract-plugin
export default {"Interface":"Interface_Interface__NTrln","EscapeMessage":"Interface_EscapeMessage__aVeou"};